import { useFormikContext } from 'formik';

import { DataCollectionValues } from '../../types/DataCollectionValues';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useDataCollection = () => {
    return useFormikContext<DataCollectionValues>();
};
